module.exports = __webpack_public_path__ + "img/login-bg.18197fb7.png";